<template>
  <v-card
      v-if="node"
      ref="node"
      @click="(event) => handleSpecialClick(event)"
      @contextmenu.stop="showNodeMenu($event)"
      :ripple="false"
      class="pertimm-node"
      max-width="300"
      width="300"
      outlined
      @mouseenter="hoverbtn = true"
      @mouseleave="hoverbtn = false"
      :style="{ zIndex: isSelected ? maxZIndex : defaultZIndex }"
  >
    <v-card-title class="justify-center text-justify subtitle-2 py-0">
      <!-- Goal : Delete this chekbox and turn it to action -->
      <!-- <v-checkbox
        @change="
          updateNode({
            skillId: $route.params.skillId,
            idNode: node._id,
            data: node
          })
        "
        v-model="node.waitUserInput"
      ></v-checkbox> -->
      <v-text-field
          v-model="node.name"
          color="black"
          v-if="nameEditMode"
          @blur="enableNameEditMode(false)"
          @keyup.enter="enableNameEditMode(false)"
          class="node-name-input pa-0 ma-0"
      ></v-text-field>
      <p
          style="cursor: pointer"
          v-else
          @dblclick="enableNameEditMode(true)"
          class="node-name-label d-flex text-truncate justify-center align-center py-0 my-0"
      >
        {{ node.name || "..." }}
      </p>
    </v-card-title>

    <v-divider v-if="!nameEditMode" class="mx-4"></v-divider>

    <v-row>
      <div style="position: absolute; top:-26px; right: 0">
        <div v-if="loadingLog">
          <v-progress-circular
              indeterminate
              size="12"
              width="2"
              style="color: #3796f3"
          />
        </div>

        <v-icon
            v-else
            style="width: 20px !important; padding: 0 !important; height: 24px !important; color: #3796f3"
            @click="getLogByNode(node._id)"
        >
          mdi-alert-box
        </v-icon>
      </div>
    </v-row>

    <v-container class="py-0" style="position: relative; overflow: hidden">
      <!-- Added actions -->
      <v-row>
        <div
            style="position: absolute; width: 30px; height: 30px; border-radius: 50px; right: -13px; top:-13px; background-color: red"
            v-if="hasUnreadMessageActions(node.actions)"
        >
        </div>
      </v-row>
      <v-row>
        <v-col class="pb-0 actions-bloc">
          <div class="d-flex flex-column">
            <!-- Actions List -->
            <div
                class="d-flex align-center wrap-action"
                :class="`wrap-action-${action.actionType}`"
                @contextmenu="show()"
                v-for="(action, i) in node.actions"
                :key="i"
            >
              <span
                  style="cursor: pointer; width: 100%;"
                  class="caption"
                  @dblclick="handleDoubleClickOnAction(i, action)"
              >
                <span
                    v-if="action.actionType === 'message'"
                    @contextmenu.stop="showActionMenu($event, action)"
                    class="d-flex flex-column text-left mt-1"
                    style="width: 100%; background-color: #F2F2F2; border-radius: 10px; font-size: 10px; margin-bottom: 5px;  padding: 2px;"
                >
                  <span
                      class="ml-1 font-weight-regular black--text"
                      style="line-height: normal; letter-spacing: normal; font-size: 14px;"
                  >
                    {{
                      action.actionType === "message"
                          ? getFirstMessage(action)
                          : action.name
                    }}
                  </span>
                  <span
                      v-if="actionMessages.args.length > 1"
                      style="font-style: italic; font-size: 7px;"
                  >
                    paraphrases
                  </span>
                </span>
                <span
                    v-else-if="action.actionType === 'vikyAction'"
                    @contextmenu.stop="showActionMenu($event, action)"
                    class="font-weight-regular black--text text-center"
                    style="display: block; padding: 2px; width: 100%; border-radius: 10px; font-size: 10px;"
                    :style="action.name.includes('long') ? 'background-color: #FFE7E7;':'background-color: #FFF7C8;'"
                >
                  {{ action.name.includes('long') ? action.name : "Waiting for a short response"  }}
                </span>
                <span
                    v-else-if="action.actionType === 'nextSkill'"
                    @contextmenu.stop="showActionMenu($event, action)"
                    class="text-left mt-1"
                    style="position:relative;  display: block; padding: 2px; width: 100%; background-color: #63AB52; border-radius: 10px; font-size: 10px;"
                >
                  <v-icon title="Open skill">mdi-arrow-right-bold</v-icon>
                  <span class="ml-1 font-weight-regular black--text">
                    {{ getSkillName(action.args[0]) }}
                  </span>

                    <div
                        style="
                          position: absolute;
                          top: 4px;
                          right: 7px;
                        "
                        title="Open skill"
                        @click="openSkill(action.args[0])"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4m-8-2l8-8m0 0v5m0-5h-5" />
                      </svg>
                    </div>

                </span>
                <span
                    v-else
                    class="text-left mt-1 mb-1"
                    @contextmenu.stop="showActionMenu($event, action)"
                    style="display: block; width: 100%; background-color: #CEBCFF; border-radius: 10px; font-size: 10px; padding: 2px;"
                >
                  <span class="ml-1 font-weight-regular black--text">
                    {{ action.name }}
                  </span>
                </span>
              </span>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Actions menu -->
      <v-row>
        <v-col class="pt-2">
          <div class="d-flex flex-column align-center">
            <template>
              <div v-if="node.actions.length < 1">
                <v-btn tex icon small color="primary" @click="dialog = true">
                  <v-icon>mdi-playlist-plus</v-icon>
                </v-btn>
              </div>
            </template>
            <v-dialog v-model="dialog" width="500">
              <v-card>
                <div class="d-flex flex-column align-center">
                  <div class="pt-4">
                    <v-btn
                        text
                        @click="handleSendMessages();"
                    >Send message</v-btn
                    >
                  </div>
                  <div id="viky" class="pt-4">
                    <v-btn
                        text
                        @click="
                        action.actionType = 'vikyAction';
                        action.args[0] = '';
                        action.name = 'Waiting for a short response ';
                        addActions();
                      "
                    >Wait for short response</v-btn
                    >
                  </div>
                  <div id="viky" class="pt-4">
                    <v-btn
                        text
                        @click="
                        action.actionType = 'vikyAction';
                        action.args[0] = '';
                        action.name = 'Waiting for a long response ';
                        addActions();
                      "
                    >Wait for long response</v-btn
                    >
                  </div>
                  <div class="pt-4">
                    <v-btn
                        text
                        @click="
                        dialogAction = true;
                        action.actionType = 'clearSlots';
                        action.args[0] = '';
                        action.name = '';
                      "
                    >Clear Slots</v-btn
                    >
                  </div>
                  <!-- NextSkill Action : disabled -->
                  <div class="pt-4">
                    <v-btn
                        text
                        @click="
                        dialogAction = true;
                        action.actionType = 'nextSkill';
                        action.args[0] = '';
                        action.name = '';
                      "
                    >Next Story</v-btn
                    >
                  </div>
                  <div class="pt-4">
                    <v-btn
                        text
                        @click="
                        dialogAction = true;
                        action.actionType = 'customAction';
                        action.args[0] = '';
                        action.name = '';
                      "
                    >Custom Action</v-btn
                    >
                  </div>
                  <div class="pt-4">
                    <v-btn
                        text
                        @click="
                        dialogAction = true;
                        action.actionType = 'delay';
                        action.args[0] = '';
                        action.name = '';
                      "
                    >Delay</v-btn
                    >
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-divider v-if="!nameEditMode" class="mx -4"></v-divider>

    <v-container class="py-0 mt-3">
      <v-row>
        <v-col class="pt-0 flex-grow-0">
          <div class="d-flex flex-column">
            <Anchor
                ref="anchorIn"
                v-for="anchor in anchors.in"
                :key="anchor._id"
                :id="anchor._id"
                :name="anchor.name"
                :value="anchor.value"
                :variable="anchor.variable"
                @onDeleted="onDeletedAnchor"
                @onChanged="onAnchorChanged"
                @onUpdateAnchors="updateAnchorsList($event)"
                @onConnectionAnchor="connectionAnchor($event)"
            />
          </div>
        </v-col>
        <v-col class="pt-0">
          <div class="d-flex flex-column align-end">
            <Anchor
                ref="anchorOut"
                v-for="anchor in sortedOutAnchors"
                :key="anchor._id"
                :id="anchor._id"
                :name="anchor.name"
                :value="anchor.value"
                :variable="anchor.variable"
                :allAnchors="anchors"
                :currentNodeId="id"
                :languetteColor="anchor.color"
                :currentSkillId="$route.params.skillId"
                :isEnd="node.end"
                :available="anchor.available"
                :openedMenuAnchor="openedMenuAnchor"

                @menuOpened="openedMenuAnchor = $event"
                @onDeleted="onDeletedAnchor"
                @onChanged="onAnchorChanged"
                @onUpdateAnchors="updateAnchorsList($event)"
                @onConnectionAnchor="connectionAnchor($event)"
                @onMarkEndNode="markEndNode($event)"
                @onMarkNonAvailableNode="MarkNonAvailableNode($event)"
                @onHoverAnchor="handleHoverAnchor($event)"
                out
            />
          </div>
        </v-col>
      </v-row>
      <v-row style="position: absolute; bottom: 2px; right: 117px;">
        <v-col class="pa-0">
          <div class="d-flex flex-column align-end">
            <NewAnchor out @created="createAnchorOnEvent" />
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- Save the present node -->
    <!-- <slot v-if="!node.isSaved">
      <v-btn icon x-small color="blue lighten-2" title="Set as favourite">
        <span  @click="setFavourite">
          <v-icon>mdi-bookmark-outline</v-icon>
        </span>
      </v-btn>
    </slot>
    <slot v-if="node.isSaved">
      <v-btn icon x-small color="blue lighten-2" title="Unset from favourite">
        <span  @click="unsetFavourite">
          <v-icon>mdi-bookmark</v-icon>
        </span>
      </v-btn>
    </slot> -->

    <!-- labo-->
    <!-- <slot v-if="hover">
      <v-btn icon small color="green">
        <span  @click="show">
          <v-icon>mdi-access-point</v-icon>
        </span>
      </v-btn>
    </slot> -->
    <!-- End of my labo -->
    <v-dialog v-model="showLog" width="700" >
      <v-card >
        <v-card-title>
          <span class="headline">Log</span>
        </v-card-title>
        <div style=" overflow-y: auto; height: 500px" v-show="dataLog.length > 0">
          <v-list
              v-for="logItem in dataLog"
              :key="logItem._id"
              class="d-flex align-center"
              style="padding: 0 !important;"
          >
            <v-list-item>
              <v-list-item-content  style="background-color: ghostwhite; border: 1px solid #e6e6e6; border-radius: 8px; margin-bottom: 10px; padding: 20px; ">
                <div style="margin-bottom: 10px;">
                  <b>Id:</b> {{logItem._id}}
                </div>
                <div style="margin-bottom: 10px;">
                  <b>IDPatient:</b> {{logItem.IDPatient}}
                </div>
                <div style="margin-bottom: 10px;">
                  <b>IDSeance:</b> {{logItem.IDSeance}}
                </div>
                <div style="margin-bottom: 10px;">
                  <b>TurnTalkId:</b> {{logItem.turnTalkId}}
                </div>
                <div style="margin-bottom: 10px;">
                  <b>NodeId:</b> {{logItem.nodeId}}
                </div>
                <div style="margin-bottom: 10px;">
                  <b>Bot:</b> {{logItem.bot}}
                </div>
                <div style="margin-bottom: 10px;">
                  <b>Patient:</b> {{logItem.patient}}
                </div>
                <div>
                  <b>Anchor:</b> {{logItem.anchor}}
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
        <div v-show="dataLog.length === 0">
          <v-list-item>
            <v-list-item-content style="background-color: ghostwhite; border: 1px solid #e6e6e6; border-radius: 8px; margin-bottom: 10px; padding: 20px; ">
              <div>Il n'y a pas de log</div>
            </v-list-item-content>
          </v-list-item>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="showLog = false"
          >Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAction" width="800" persistent>
      <v-card>

        <div
            class="paragraph"
            v-for="(paragraph, index) in actionMessages.args"
            :key="index"
            v-if="action.actionType === 'message'"
        >
          <v-btn
              variant="outlined"
              icon
              color="red"
              @click="listenToParagraph(paragraph, index)"
          >
            <v-icon>mdi-headphones</v-icon>
          </v-btn>
          <v-textarea
              ref="textarea"
              auto-grow
              class="mt-1 custom-textarea"
              rows="3"
              row-height="25"
              outlined
              rounded
              @input="handleInput($event,index)"
              @keyup="getCursuroPosition($event,index)"
              @focus="handleFocusMessageBlock(index)"
              @click.stop="getCursuroPosition($event, index)"
              v-model="actionMessages.args[index]"
          ></v-textarea>
          <div style="display: flex; flex-direction: column;">
            <!-- <v-badge color="green" class="ml-2 mr-4">
              <template v-slot:badge>
                <span class="mdi mdi-comment"></span>
              </template>
            </v-badge> -->
            <v-btn
                variant="outlined"
                icon
                color="red"
                @click="clearMessageBlock(index)"
                class="ml-2 mr-2"
                :disabled="actionMessages.args.length < 2"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-btn
                variant="outlined"
                icon
                color="red"
                @click=""
                class="ml-2 mr-2"
            >
              <v-icon color="green">mdi-comment</v-icon>
            </v-btn>
          </div>
          <!-- <span style="line-height: 20px;" v-html="paragraph"> </span> -->
        </div>

        <div style="width: 20%;
                          background-color: #E7E7E7;
                          border-radius: 25px;
                          display: flex;
                          flex-direction: row;
                          flex-wrap: nowrap;
                          align-items: center;
                          margin: 0 auto;
                          cursor: pointer;"
             @click="addParaphrases(actionIndex)"
             v-if="action.actionType === 'message'"
        >
          <span class="mdi mdi-plus-circle" style="font-size: larger;"></span>
          <span style="font-size: x-small; margin-left: 5px;">Ajouter une paraphrase</span>
        </div>

        <div v-if="action.actionType === 'clearSlots'">
          <v-text-field
              class="px-4"
              placeholder="Name"
              v-model="action.name"
          ></v-text-field>
        </div>

        <div v-if="action.actionType === 'nextSkill'">
          <!-- <v-text-field class="px-4" placeholder="Name" v-model="action.name"></v-text-field> -->
          <v-select
              class="px-4"
              :items="skills"
              item-text="name"
              item-value="_id"
              v-model="action.args[0]"
              label="Next Story"
          ></v-select>
        </div>
        <div v-if="action.actionType === 'customAction'">
          <v-text-field
              class="px-4"
              placeholder="Name"
              v-model="action.name"
          ></v-text-field>
          <PrismEditor
              class="my-editor"
              v-model="action.args[0]"
              :highlight="highlighter"
              line-numbers
              language="javascript"
          ></PrismEditor>
        </div>
        <div v-if="action.actionType === 'delay'">
          <v-text-field
              class="px-4"
              placeholder="Name"
              v-model="action.name"
          ></v-text-field>
          <v-text-field
              class="px-4"
              v-model="action.args[0]"
              type="number"
              placeholder="Seconds"
          ></v-text-field>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" class="white-text" @click="cancelAddAction()">
            cancel
          </v-btn>
          <!--          <v-btn-->
          <!--            v-if="action.actionType !== 'message'"-->
          <!--            color="secondary"-->
          <!--            @click="addActions()"-->
          <!--            :disabled="!action.name && !action.args[0] "-->
          <!--            >-->
          <!--            add-->
          <!--          </v-btn>-->
          <div  v-if="action.actionType !== 'message'" style="margin-left: 8px">
            <v-btn
                v-if="!saving"
                color="secondary"
                @click="addActions()"
                :disabled="!action.name && !action.args[0] "
            >
              add
            </v-btn>
            <v-btn
                v-else
                color="secondary"
                style="width: 70px"
            >
              <v-progress-circular
                  indeterminate
                  size="14"
                  width="2"
              />
            </v-btn>
          </div>
          <div v-else style="margin-left: 8px">
            <v-btn
                v-if="!saving"
                color="secondary"
                @click="addActions()"
                :disabled="isArgsEmpty"
                style="width: 70px"
            >
              add
            </v-btn>
            <v-btn
                v-else
                color="secondary"
                style="width: 70px"
            >
              <v-progress-circular
                  indeterminate
                  size="14"
                  width="2"
              />
            </v-btn>
          </div>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogEditAction"
        width="800"
        v-if="node.actions[actionIndex]"
        persistent
    >
      <v-card>
        <div
            class="pt-4 px-4"
            v-if="node.actions[actionIndex].actionType === 'message'"
        >
          <!-- <v-text-field class="px-4" placeholder="Name" v-model="node.actions[actionIndex].name"></v-text-field> -->
          <!-- <v-textarea
            v-if="editingMessage"
            id="textAreaMessage"
            class="px-4"
            placeholder="Message"
            v-model="node.actions[actionIndex].args[0]"
          ></v-textarea> -->
          <div style="display: flex; flex-wrap: wrap; justify-content: space-evenly;">
            <div style="display: flex; flex-wrap: nowrap; width:100%; justify-content: space-between;">
              <v-btn color="#F8E35A" @click.stop="handleEmotion('ENTHOUSIASTE')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Enthousiaste</v-btn>
              <v-btn color="#F8E35A" @click.stop="handleEmotion('EVIDENCE')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Evidence</v-btn>
              <v-btn color="#F8E35A" @click="handleEmotion('ESPIEGLE')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Espiegle</v-btn>
              <v-btn color="#B3D5F7" @click.stop="handleEmotion('RECONFORTANT')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Réconfortant</v-btn>
              <v-btn color="#B3D5F7" @click.stop="handleEmotion('PENSIF')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Pensif</v-btn>
              <v-btn color="#FB9F9F" @click.stop="handleEmotion('COLERE')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Colère</v-btn>
            </div>
            <div style="display: flex; flex-wrap:nowrap; width:100%; justify-content: space-between; margin-top: 10px; margin-bottom: 10px;">
              <v-btn color="#E1E1E1" @click.stop="handleEmotion('NARRATION')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Narration</v-btn>
              <v-btn color="#F8E35A" @click.stop="handleEmotion('INCREDULE')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Incredule</v-btn>
              <v-btn color="#F8E35A" @click.stop="handleEmotion('ETONNE')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Etonné</v-btn>
              <v-btn color="#B3D5F7" @click.stop="handleEmotion('DESOLE')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Désolé</v-btn>
              <v-btn color="#CEBCFF" @click.stop="handleEmotion('SUPPLIANT')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Suppliant</v-btn>
              <v-btn color="#FF9E3D" @click.stop="handleEmotion('DETERMINE')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Determiné</v-btn>
            </div>
            <!-- <v-btn
              v-for="(emotion, index) in emotions"
              :key="index"
              :color="emotion.color"
              @click="handleEmotion(emotion.name)"
              style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;"
            >
              {{ emotion.label }}
            </v-btn> -->
          </div>
          <div
              class="paragraph"
              v-for="(paragraph, index) in actionMessages.args"
              :key="index"
          >
            <v-btn
                variant="outlined"
                icon
                :color="readed[index] ? 'green' : 'red'"
                @click="listenToParagraph(paragraph, index, true)"
            >
              <v-progress-circular
                  v-if="loadingAudioIsParaph && activeIndexIsParaph === index"
                  indeterminate
                  color="green"
                  size="14"
                  width="2"
              />
              <v-icon v-else>mdi-headphones</v-icon>
            </v-btn>
            <v-textarea
                ref="textareas"
                auto-grow
                class="mt-1 custom-textarea"
                rows="3"
                row-height="25"
                outlined
                rounded
                @input="handleInput($event,index)"
                @keyup="getCursuroPosition($event,index)"
                @focus="handleFocusMessageBlock(index)"
                @click.stop="getCursuroPosition($event, index)"
                v-model="actionMessages.args[index]"
            ></v-textarea>
            <div style="display: flex; flex-direction: column;">
              <!-- <v-badge color="green" class="ml-2 mr-4">
                <template v-slot:badge>
                  <span class="mdi mdi-comment"></span>
                </template>
              </v-badge> -->
              <v-btn
                  variant="outlined"
                  icon
                  color="red"
                  @click="generateParaphrase(index)"
                  class="ml-2 mr-2"
              >
                <v-progress-circular
                    v-if="loadingGP && activeIndexIsParaph === index"
                    indeterminate
                    color="green"
                    size="14"
                    width="2"
                />
                <div v-else>
                  <img :src="imgMicon" alt="My Image" style="width: 18px">
                </div>

              </v-btn>
              <v-btn
                  variant="outlined"
                  icon
                  color="red"
                  @click="clearMessageBlock(index)"
                  class="ml-2 mr-2"
                  :disabled="actionMessages.args.length < 2"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
            <!-- <span style="line-height: 20px;" v-html="paragraph"> </span> -->
          </div>

          <!-- LISTE PARAPHRASE GENERATED -->
          <div
              class="paragraph"
              v-for="(paragraphs, paraphIndex) in paraphraseGenerated"
              :key="'paraphraseGenerated-' + paraphIndex"
          >
            <v-btn
                variant="outlined"
                icon
                :color="'red'"
                @click="listenToParagraph(paragraphs, paraphIndex)"
            >
              <v-progress-circular
                  v-if="loadingAudioNoParaph && activeIndexNoParaph === paraphIndex"
                  indeterminate
                  color="red"
                  size="14"
                  width="2"
              />
              <v-icon v-else>mdi-headphones</v-icon>
            </v-btn>
            <v-textarea
                ref="textareasPG"
                auto-grow
                class="mt-1 custom-textarea-pg red-outline commentTextareaPG"
                rows="3"
                row-height="25"
                rounded
                @input="handleInputParaphraseGenerated($event,paraphIndex)"
                @keyup="getCursuroPositionPG($event,paraphIndex)"
                @focus="handleFocusMessageBlockPG(paraphIndex)"
                @click.stop="getCursuroPositionPG($event, paraphIndex)"
                v-model="paraphraseGenerated[paraphIndex]"
            ></v-textarea>
            <div style="display: flex; flex-direction: column;">
              <v-btn
                  variant="outlined"
                  icon
                  color="red"
                  @click="addToMsgParaphrase(paraphIndex)"
                  class="ml-2 mr-2"
              >
                <v-icon color="green">mdi-check-circle</v-icon>
              </v-btn>
              <v-btn
                  variant="outlined"
                  icon
                  color="red"
                  @click="clearParaphraseGenerated(paraphIndex)"
                  class="ml-2 mr-2"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
          </div>
          <!-- END LISTE PARAPHRASE GENERATED -->



          <div style="width: 20%;
                          background-color: #E7E7E7;
                          border-radius: 25px;
                          display: flex;
                          flex-direction: row;
                          flex-wrap: nowrap;
                          align-items: center;
                          margin: 0 auto;
                          cursor: pointer;"
               @click="addParaphrase(actionIndex)"
          >
            <span class="mdi mdi-plus-circle" style="font-size: larger;"></span>
            <span style="font-size: x-small; margin-left: 5px;">Ajouter une paraphrase</span>
          </div>
        </div>
        <div v-if="node.actions[actionIndex].actionType === 'clearSlots'">
          <v-text-field
              class="px-4"
              placeholder="Name"
              v-model="node.actions[actionIndex].name"
          ></v-text-field>
          <v-combobox
              v-model="node.actions[actionIndex].args[0]"
              :items="getItems(node.actions[actionIndex].args[0])"
              class="px-4"
              label="Slots"
              multiple
              small-chips
          ></v-combobox>
        </div>
        <div
            v-if="node.actions[actionIndex].actionType === 'nextSkill'"
            style="padding-top: 5px;"
        >
          <!-- <v-text-field class="px-4" placeholder="Name" v-model="node.actions[actionIndex].name"></v-text-field> -->
          <v-select
              class="px-4"
              :items="skills"
              item-text="name"
              item-value="_id"
              v-model="node.actions[actionIndex].args[0]"
              label="Next Story"
          ></v-select>
        </div>
        <div v-if="node.actions[actionIndex].actionType === 'customAction'">
          <v-text-field
              class="px-4"
              placeholder="Name"
              v-model="node.actions[actionIndex].name"
          ></v-text-field>
          <PrismEditor
              class="my-editor"
              v-model="node.actions[actionIndex].args[0]"
              :highlight="highlighter"
              line-numbers
              language="javascript"
          ></PrismEditor>
        </div>
        <div v-if="node.actions[actionIndex].actionType === 'delay'">
          <v-text-field
              class="px-4"
              placeholder="Name"
              v-model="node.actions[actionIndex].name"
          ></v-text-field>
          <v-text-field
              class="px-4"
              v-model="node.actions[actionIndex].args[0]"
              type="number"
              placeholder="Seconds"
          ></v-text-field>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="#F8F8F8"
              plain
              class="black-text"
              style="font-weight: 900;"
              @click="closeDialog()"
          >
            cancel
          </v-btn>
          <v-btn
              color="secondary"
              class="white-text"
              style="font-weight: 900;"
              :disabled="isDisabledSave(actionIndex)"
              @click="startSaving(); updateActions(node.actions[actionIndex])"
          >
            <v-progress-circular
                v-if="saving"
                indeterminate
                size="14"
                width="2"
            />
            <span v-else>Save</span>
          </v-btn>
          <!-- Pour actionType === 'message' -->
          <!-- <v-btn
            v-if="
              node.actions[actionIndex].actionType === 'message' &&
                this.editingMessage
            "
            color="primary"
            class="white-text"
            @click="editingMessage = false"
          >
            listen
          </v-btn> -->

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-menu
        v-model="showMenu"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
        close-on-content-click
        :min-width="200"
    >
      <template v-slot:activator="{ on }">
        <div class="jsPlumb-canvas-container22" @contextmenu="show">
          <slot v-on="on"></slot>
        </div>
      </template>
      <v-list dense>
        <v-list-item v-for="(item, index) in items" :key="index" :disabled="shouldShowItem(item)" :style="{ opacity: shouldShowItem(item) ? 0.5 : 1 }">
          <div>
            <v-list-item @click="callAction(item.action)">
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </div>
        </v-list-item>
        <v-list-item
            v-if="shouldDisplayConnectionAction && showConnectionAction"
        >
          <div>
            <v-list-item @click="callAction('connectNode')">
              <v-list-item-icon>
                <v-icon v-text="'mdi-link-variant'"></v-icon>
              </v-list-item-icon>
              <v-list-item-title>Connection</v-list-item-title>
            </v-list-item>
          </div>
        </v-list-item>
        <v-list-item>
          <div>
            <v-list-item @click="handleBookmark()">
              <v-list-item-icon>
                <v-icon
                    v-text="
                    node.isSaved ? 'mdi-bookmark-remove' : 'mdi-bookmark-check'
                  "
                ></v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                  node.isSaved ? "Supprimer des favoris" : "Ajouter aux favoris"
                }}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-chat</v-icon>
              </v-list-item-icon>
              <v-list-item-title
                  @click="startChat"
                  style="text-decoration: none; color: inherit; cursor: pointer;"
              >
                Start chat from node
              </v-list-item-title>
            </v-list-item>
          </div>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu
        v-model="actionMenu"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
        close-on-content-click
        :min-width="200"
        class="v-menu-canvas-link"
    >
      <v-list-item style="background-color: white" @click="dialog = true">
        <v-list-item-icon>
          <v-icon>mdi-plus-thick</v-icon>
        </v-list-item-icon>
        <v-list-item-title>New Action</v-list-item-title>
      </v-list-item>
      <v-list-item
          style="background-color: white"
          @click="removeActions(actionContextMenu._id, actionContextMenu.name)"
      >
        <v-list-item-icon>
          <v-icon>mdi-delete</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Delete Action</v-list-item-title>
      </v-list-item>
      <v-list-item
          v-if="actionIndex != 0"
          style="background-color: white"
          @click="moveActions(node.actions, actionIndex, actionIndex - 1)"
      >
        <v-list-item-icon>
          <v-icon>mdi-arrow-up-thick</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Move up</v-list-item-title>
      </v-list-item>
      <v-list-item
          v-if="actionIndex != node.actions.length - 1"
          style="background-color: white"
          @click="moveActions(node.actions, actionIndex, actionIndex + 1)"
      >
        <v-list-item-icon>
          <v-icon>mdi-arrow-down-thick</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Move down</v-list-item-title>
      </v-list-item>
    </v-menu>

    <!-- Commentaire (Show - Edit - Save)-->
    <div
        v-if="node.comment || editingComment"
        class="text-left mt-1"
        @mouseover="handleExpandComment"
        @mouseout="handleExpandComment"
        @dblclick="EnableEditingComment"
        style="position: absolute; width: 100%; border-radius: 25px; z-index: 999"
    >
      <div
          v-if="!editingComment"
          class="h-100 w-100 d-flex align-start pa-1 text-wrap"
          style="background-color: lemonchiffon;
            border: thin solid rgba(0, 0, 0, 0.12);
            border-radius: 25px;"
          @contextmenu.stop.prevent="openCommentMenu($event)"
      >
        <span
            class="flex-grow-1 d-block pa-2"
            :class="!expandComment ? 'text-truncate' : ''"
            style="width: 265px; word-wrap: break-word;"
        >
          {{ node.comment }}
        </span>

        <v-icon class="mt-2">{{
            !expandComment ? "mdi-chevron-down" : "mdi-chevron-up"
          }}</v-icon>
      </div>

      <div
          v-else
          class="d-flex flex-wrap align-start pa-1 mt-1"
          style="border: thin solid rgba(0, 0, 0, 0.12);
                  border-radius: 25px;
                  background-color: white;
                  z-index: 999"
      >
        <v-textarea
            hide-details
            no-resize
            v-model="node.comment"
            placeholder="Ajouter votre commentaire ici...!"
            @keydown.enter.prevent="addComment"
            class="flex-grow-1 pa-1 mr-4 commentTextarea"
        >
        </v-textarea>

        <v-icon
            class="pa-1 align-start"
            style="position: absolute; right: 4px;"
            @click="handleCommentToggle"
        >
          {{
            expandComment && EnableEditingComment
                ? "mdi-chevron-down"
                : "mdi-chevron-up"
          }}
        </v-icon>

        <div class="flex-grow-1 d-flex justify-end">
          <v-btn
              color="success"
              class="mt-2 mb-1 ml-2 mr-1"
              @click="addComment"
          >
            Save
          </v-btn>
        </div>
      </div>

      <v-menu
          v-model="showCommentMenu"
          :position-x="x"
          :position-y="y"
          absolute
          offset-y
          close-on-content-click
          :min-width="200"
      >
        <template v-slot:activator="{ on }">
          <slot v-on="on"></slot>
        </template>
        <span
            class="d-flex h-bg-white pa-1"
            style="background-color: white; height: 30px; cursor: pointer;"
            @click="deleteComment"
        >Supprimer commentaire</span>
      </v-menu>
    </div>

  </v-card>
</template>

<script>
import {mapActions, mapState} from "vuex";

import Anchor from "./Anchor";
import NewAnchor from "./NewAnchor";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css";
import micon from '../../assets/micon.png'

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    excludedNode: {
      type: String,
      required: false,
    },
    showConnectionAction: {
      type: Boolean,
      required: true,
    },
    nodeSelected: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
    maxZIndex: {
      type: Number,
      required: true,
    },
    defaultZIndex: {
      type: Number,
      required: true,
    }
  },
  components: {
    Anchor,
    NewAnchor,
    PrismEditor,
  },
  data() {
    return {
      imgMicon: micon,
      loadingAudioIsParaph: false,
      loadingAudioNoParaph: false,
      loadingGP: false,
      activeIndexIsParaph: null,
      activeIndexNoParaph: null,
      dataLog: [],
      paraphraseGenerated: [],
      showLog: false,
      saving: false,
      loadingLog: false,
      caratereAutorise: `♀♂$[]§«»<0123456789>ÀÂÇÉÊÎÔàâæçèéêëîïôùûü¬~#"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-!'(){}_-+/*=,.:;?’ \n`,
      readed: [],
      waitUserInput: true,
      inputNameValue: "",
      dialog: false,
      dialogAction: false,
      dialogGlobalAction: false,
      dialogEditAction: false,
      actionIndex: 0,
      action: { name: "", args: [], actionType: "message" },
      actionMessages: { name: "", args: [], argsReaded: [], actionType: "message"},
      nameEditMode: false,
      node: null,
      //actionMessages.args:[],
      blockMessageFocusedIndex: null,
      blockMessageFocusedIndexPG: null,
      isTextareaFocused: false,
      isTextareaPGFocused: false,
      MessageCursorPosition: 0,
      messageBlockEvent: null,
      emotions: [
        { name: "ENTHOUSIASTE", label: "Enthousiaste", color: "#F8E35A" },
        { name: "EVIDENCE", label: "Evidence", color: "#F8E35A" },
        { name: "ESPIEGLE", label: "Espiegle", color: "#F8E35A" },
        { name: "RECONFORTANT", label: "Réconfortant", color: "#B3D5F7" },
        { name: "PENSIF", label: "Pensif", color: "#B3D5F7" },
        { name: "COLERE", label: "Colère", color: "#FB9F9F" },
        { name: "NARRATION", label: "Narration", color: "#E1E1E1" },
        { name: "INCREDULE", label: "Incredule", color: "#F8E35A" },
        { name: "ETONNE", label: "Etonné", color: "#F8E35A" },
        { name: "DESOLE", label: "Désolé", color: "#B3D5F7" },
        { name: "SUPPLIANT", label: "Suppliant", color: "#CEBCFF" },
        { name: "DETERMINE", label: "Determiné", color: "#FF9E3D" }
      ],
      isLoading: false,
      search: null,
      actions: [],
      filterAction: { q: null, sort: "recentAsc", page: 1 },
      sortingOptions: [
        { name: "Oldest", value: "recentDesc" },
        { name: "Recent", value: "recentAsc" },
      ],
      loding: false,
      noMoreAction: false,
      //skills: [],
      nodeId: "",
      hoverbtn: false,
      items: [
        {
          title: "Dupliquer",
          icon: "mdi-content-copy",
          action: "cloneNode",
        },
        {
          title: "Supprimer",
          icon: "mdi-delete",
          action: "deleteNode",
        },
        {
          title: "Commentaire",
          icon: "mdi-comment",
          action: "commentNode",
        },
        {
          title: "Copier une selection",
          icon: "mdi-selection-multiple",
          action: "duplicateSelection",
        },
      ],
      showMenu: false,
      x: 0,
      y: 0,
      editingMessage: false,
      expandComment: false,
      editingComment: false,
      showCommentMenu: false,
      actionMenu: false,
      actionContextMenu: null,
      showAddActionButton: true,
      //Add user
      userId: 1258089477,
      name: "User",
      patientId: "",
      demoPatientId: process.env.DEFAULT_PATIENT_ID || 'aa104951-58cc-4372-a567-0e02b2c3d470',
      //
      openedMenuAnchor: null,
    };
  },

  methods: {
    ...mapActions({
      createAnchor: "http/anchors/createAnchor",
      updateAnchor: "http/anchors/updateAnchor",
      removeAnchor: "http/anchors/removeAnchor",
      updateNode: "http/nodes/updateNode",
      getNode: "http/nodes/getNode",
      cloneNode: "http/nodes/cloneNode",
      removeNode: "http/nodes/removeNode",
      getActions: "http/nodes/getActions",
      addAction: "http/nodes/addAction",
      sendActions: "http/nodes/sendActions",
      updateAction: "http/nodes/updateAction",
      removeAction: "http/nodes/removeAction",
      loadAnchorTypes: "http/anchors/loadAnchorTypes",
      addSavedNodeToTemplate: "canvas/addSavedNode",
      removeSavedNodeFromTemplate: "canvas/removeSavedNode",
    }),
    handleClick() {
      this.$emit('onUpdateNodeSelected', this.nodeSelected); // Émet l'événement de sélection au parent
    },
    getLogByNode(nodeId) {
      this.loadingLog = true;
      this.$http
          .get(`/nodes/${nodeId}/logs`)
          .then((response) => {
            this.dataLog = response.data;
            this.showLog = true;
            this.loadingLog = false
          })
          .catch((err) => {
            console.log('Error lors de chargement des logs', err)
          })
    },
    openSkill(idSkill) {
      localStorage.removeItem("panzoom_position");
      this.$router.push(
          `/projects/${this.$route.params.id}/skills/${idSkill}`
      );
      location.reload();
    },
    hasUnreadMessageActions(actions) {
      // First, filter the actions where type is 'message'
      const messageActions = actions.filter(
          (action) => action.actionType === 'message'
      );

      // Then, check if there is any action where 'argsReaded' contains 'false'
      return messageActions.some((action) =>
          action.argsReaded && action.argsReaded.includes(false)
      );
    },
    getItems(args) {
      // Return empty array if args[0] is empty or not an array
      if (!args || !Array.isArray(args)) {
        return [];
      }
      return args;
    },
    isDisabledSave(actionIndex) {
      if (
          this.node.actions[actionIndex].actionType === 'delay' ||
          this.node.actions[actionIndex].actionType === 'customAction' ||
          this.node.actions[actionIndex].actionType === 'clearSlots' ||
          this.node.actions[actionIndex].actionType === 'nextSkill'
      ) {
        return !(this.node.actions[actionIndex].args[0] && this.node.actions[actionIndex].args[0].length)
      }
      else {
        return this.isArgsEmpty
      }
    },
    startSaving() {
      this.saving = true;
    },
    focusPrism(event) {
      const prismTextarea = event.target.querySelector(
          ":scope > .prism-editor__container textarea"
      );
      if (prismTextarea) {
        prismTextarea.focus();
      }
    },
    highlighter(code) {
      return highlight(code, languages.js); //returns html
    },

    async filter() {
      this.filterAction.page = 1;
      this.actions = await this.getActions({ filter: this.filterAction });
    },
    // async showMore() {
    //   this.loding = true;
    //   this.filterAction.page += 1;
    //   const newActions = await this.getActions({ filter: this.filterAction });
    //   this.actions.push(...newActions);
    //   this.loding = false;
    //   if (newActions.length === 0) this.noMoreAction = true;
    // },
    // async getIntents() {
    //   const data = await this.$store.dispatch("http/intents/get", {
    //     this.$route.params.id: this.$route.params.id,
    //   });
    //   this.intents = data;
    // },
    handleSendMessages() {
      if (
          this.node.actions.map((x) => x.actionType).includes("message") &&
          this.actionMessages.actionType === "message"
      ) {
        this.$toasted
            .error("Message Action already exists for this node!")
            .goAway(3000);
      } else {
        this.dialogAction = true;
        this.action.actionType = 'message'
        this.actionMessages.actionType = 'message';
        this.actionMessages.args[0] = '';
        this.actionMessages.name = '';
        this.actionMessages.argsReaded = false
      }
    },
    cancelAddAction(){
      this.dialogAction = false;
      this.actionMessages.args = [];
    },
    async addActions() {
      let eventData = {
        anchors: this.anchors,
        node: this.$refs.node,
        nodeId: this.id,
      };
      this.$emit("onUpdateNode",eventData);
      if (
          this.node.actions.map((x) => x.actionType).includes("vikyAction") &&
          this.action.actionType == "vikyAction"
      ) {
        this.$toasted
            .error("Waiting Action already exists for this node!")
            .goAway(3000);
      } else if (
          this.node.actions.map((x) => x.actionType).includes("message") &&
          this.action.actionType === "message"
      ) {
        this.$toasted
            .error("Message Action already exists for this node!")
            .goAway(3000);
      } else {
        this.saving = true;
        this.actionMessages.args = this.replaceInvalidCharacters(this.actionMessages.args.filter(str => str.trim() !== ""));
        await this.addAction({
          skillId: this.$route.params.skillId,
          idNode: this.id,
          action: {action : (this.action.actionType === "message" ? this.actionMessages : this.action)} ,
        });
        const node = await this.getNode({
          skillId: this.$route.params.skillId,
          idNode: this.id,
        });
        this.saving = false;
        this.node.actions = node.actions;
        this.action.name = "";
        this.action.args[0] = [];
        this.dialog = false;
        this.dialogAction = false;
        this.dialogGlobalAction = false;
        this.showAddActionButton = false;
      }
    },
    /* async sendMessage() {
       console.log('alefa any back', this.actionMessages + " " + this.actionMessages.args[0])
       await this.sendActions({
         skillId: this.$route.params.skillId,
         idNode: this.id,
         actions: { action: this.actionMessages },
       })
       const node = await this.getNode({
         skillId: this.$route.params.skillId,
         idNode: this.id,
       });
       console.log('nose azo', this.node)
       this.node.actionMessages = node.actions
       this.actionMessages.name = ""
       this.actionMessages.args[0] = [];
       this.dialog = false;
       this.dialogAction = false;
       this.dialogGlobalAction = false;
       this.showAddActionButton = false;
     },*/
    async removeActions(actionId, actionName) {
      this.$confirm(
          `Are you sure you want to delete the Action <strong>${actionName}</strong> ?`
      ).then(async (res) => {
        if (res) {
          if (this.node.actions === 0 && !this.showAddActionButton) {
            this.showAddActionButton = true;
          }
          await this.removeAction({
            skillId: this.$route.params.skillId,
            idNode: this.id,
            actionId,
          });
          const node = await this.getNode({
            skillId: this.$route.params.skillId,
            idNode: this.id,
          });
          this.node.actions = node.actions;
          this.actionMessages.args = []
        }
      });
    },
    // Moving actions up and down && updating
    async moveActions(actionsList, from, to) {
      actionsList.splice(to, 0, actionsList.splice(from, 1)[0]);
      const currentNode = await this.getNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
      });
      const nodeActionsList = currentNode.actions;
      nodeActionsList.splice(to, 0, nodeActionsList.splice(from, 1)[0]);
      await this.updateNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
        data: { actions: nodeActionsList },
      });
    },
    // Event updating anchors list
    updateAnchorsList(value) {
      // If the present node is the default one -> "acnhors.in" list is empty. If not, I cut the list received from parent.
      //console.log("Received value from anchors :", value);
      if (this.anchors.in.length == 0) {
        this.node.anchors = value.out;
      } else {
        var head = this.node.anchors.slice(0, 2);
        var finalList = head.concat(value.out.slice(1));
        this.node.anchors = finalList;
      }
    },
    // Send to parent
    sendNodeElement() {
      this.$emit("onUpdateSelection", this.$el.id);
    },
    handleSpecialClick(event) {
      this.handleClick()
      if (event.ctrlKey || event.metaKey) {
        this.sendNodeElement();
      }
    },
    //transform plain text into html paragraphs.
    transoformToPragraphs(action) {
      let lines = action.args[0].split(/\r\n|\r|\n/);
      let paragraphs = [];
      for (let line in lines) {
        if (lines[line].slice(-1).includes(":" || "?")) {
          paragraphs.push(
              '<p class="ml-2 mr-2">' + lines[line] + "</p>\n" + "<br >"
          );
          continue;
        } else {
          paragraphs.push(
              '<p class="ml-2 mr-2 mt-1">' +
              lines[line].replace(/\n/g, "</p>\n<p>") +
              "</p>\n"
          );
          continue;
        }
      }
      return paragraphs;
    },
    getMessage(action) {
      return action.args[0].split(/\r\n|\r|\n/);
    },
    addParaphrase() {
      this.actionMessages.args.push("");
      this.readed.push(false)
      this.$nextTick(() => {
        const lastIndex = this.actionMessages.args.length - 1;
        this.$refs.textareas[lastIndex].focus();
        this.blockMessageFocusedIndex = lastIndex;
        this.MessageCursorPosition = 0;
      });
    },
    addParaphrases() {
      this.actionMessages.args.push("");
      this.readed.push(false)
      this.$nextTick(() => {
        const lastIndex = this.actionMessages.args.length - 1;
        this.$refs.textarea[lastIndex].focus();
        this.blockMessageFocusedIndex = lastIndex;
        this.MessageCursorPosition = 0;
      });
    },
    generateParaphrase(index) {
      const firstMessageParaphrase = this.actionMessages.args[index];
      this.paraphraseGenerated = []
      this.loadingGP = true
      this.activeIndexIsParaph = index;
      this.$http
          .post(
              '/action/generate-paraphrase',
              {text: firstMessageParaphrase}
          )
          .then(res => {
            const data = res.data
                .map(str => str.replace(/^"|"$/g, ''))
                .filter(res => res !== "");  //liste proposition by Mistral IA
            if (Array.isArray(data)) {
              this.paraphraseGenerated.push(...data)
            } else {
              console.log("Unexpected data format received from API.");
            }
            this.loadingGP = false
          })
          .catch((err) => {
            console.log('Error lors de génération des paraphrases', err)
          })
    },
    addToMsgParaphrase(indexParaphrase) {
      const message = this.paraphraseGenerated[indexParaphrase]
      this.readed.push(false);
      this.actionMessages.args.push(message);
      this.paraphraseGenerated.splice(indexParaphrase, 1);
    },
    async closeDialog() {
      this.paraphraseGenerated = []
      this.editingMessage = false;
      this.dialogEditAction = false;
      const node = await this.getNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
      });
      this.node.actions = node.actions;
      this.actionMessages.args = [];
      node.actions.filter((action) => {
        if(action.actionType === "message") {
          this.actionMessages.args = action.args;
        }
      })
    },
    unRead(index) {
      if (this.readed[index] === true) {
        this.readed[index] = false;
      }
    },
    //REMOVE CARACTERE
    async handleInput(event, index) {
      // Perform your input modification as before
      this.actionMessages.args[index] = this.removeUnauthorizedCharacters(event);
      this.unRead(index)
    },
    async handleInputParaphraseGenerated(event, index) {
      // Perform your input modification as before
      this.paraphraseGenerated[index] = this.removeUnauthorizedCharacters(event);
      this.unRead(index)
    },
    removeUnauthorizedCharacters(input) {
      let lines = input.split(/\r?\n/);

      for (let i = 0; i < lines.length; i++) {
        lines[i] = lines[i].split('').filter(char => this.caratereAutorise.includes(char)).join('');
      }
      // Supprimer les caractères non autorisés
      return lines.join('\n');
    },
    //CHANGER LE CARACTERE NON AUTORISE PAR REMPLACANT CARACTERE
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    replaceInvalidCharacters(input) {
      const replacements = {
        '’': "'"
      };
      // Crée une expression régulière avec tous les caractères non autorisés
      const regex = new RegExp(`[${Object.keys(replacements).map(this.escapeRegExp).join('')}]`, 'g');

      // Traitez input comme un tableau de chaînes
      return input.map(item => {
        // Remplace les caractères non autorisés par leurs équivalents autorisés
        let output = item.replace(regex, match => replacements[match]);
        // Si certains caractères n'ont pas de remplacement, les supprimer
        return output.replace(new RegExp(`[${Object.keys(replacements).map(this.escapeRegExp).join('')}]+`, 'g'), '');
      });
    },
    async updateActions(action) {
      this.paraphraseGenerated = []
      action.argsReaded = [...this.readed]

      if (action.actionType === 'message') {
        action.args = this.replaceInvalidCharacters(action.args);
        this.actionMessages.args = this.actionMessages.args.filter(message => message.length !== 0);
        await this.updateAction({
          skillId: this.$route.params.skillId,
          idNode: this.id,
          action,
          actionId: action._id,
        });
        //action.args = this.actionMessages.args;
        action.args = this.replaceInvalidCharacters(this.actionMessages.args);
        this.actionMessages.args = this.replaceInvalidCharacters(this.actionMessages.args);
        //action.args = this.replaceInvalidCharacters(action.args);

      }
      await this.updateAction({
        skillId: this.$route.params.skillId,
        idNode: this.id,
        action,
        actionId: action._id,
      });
      const node = await this.getNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
      });
      this.node.actions = node.actions;
      // closing the dialog if we're not editing the message.
      if (!this.editingMessage) this.dialogEditAction = false;
      else this.dialogEditAction = true;
      this.editingMessage = false;
      this.saving = false;
      this.dialogEditAction = false;
    },
    removeTagsFromtext(str) {
      var start = str.indexOf(">");
      var end = str.indexOf("<", start + 1);
      var result = str.substring(start + 1, end);
      return result.replace(/\n/g, "");
    },
    transformerTexte(texte) {
      const regexVariables = /\${[^}]+}/g;

      // Utilisez la méthode replace() avec une fonction de remplacement pour les variables
      const texteSansVariables = texte.replace(regexVariables, (match) => {
        // Supprimez les caractères `${` et `}` et obtenez le nom de la variable
        const variable = match.slice(2, -1);

        // Divisez la variable en utilisant des points et renvoyez la dernière partie (nom de la variable)
        const parties = variable.split('.');
        return parties[parties.length - 1];
      });

      // Utilisez une expression régulière pour supprimer les caractères spéciaux ♀ et ♂
      const regexCaracteresSpeciaux = /♀[^♂]*[♂\W]*/g;
      const texteSansCaracteresSpeciaux = texteSansVariables.replace(regexCaracteresSpeciaux, ' ');
      const texteTransforme = texteSansCaracteresSpeciaux.replace(/\s+/g, ' ');

      return texteTransforme;
    },

    handleEmotion(emotion) {
      const {
        blockMessageFocusedIndex,
        blockMessageFocusedIndexPG,
        MessageCursorPosition,
        actionMessages,
        isTextareaFocused,
        isTextareaPGFocused
      } = this;

      if (isTextareaFocused && blockMessageFocusedIndex !== null) {
        const messageElement = this.$refs.textareas[blockMessageFocusedIndex];

        const textBefore = actionMessages.args[blockMessageFocusedIndex].substring(0, MessageCursorPosition);
        const textAfter = actionMessages.args[blockMessageFocusedIndex].substring(MessageCursorPosition);

        const emotionText = '<' + emotion + '>';
        const finalText = textBefore + emotionText + textAfter;

        this.$set(this.actionMessages.args, blockMessageFocusedIndex, finalText);

        const newPosition = textBefore.length + emotionText.length;
        this.MessageCursorPosition = newPosition;

        this.setCaretPosition(messageElement.$refs.input, newPosition);
      }

      if (isTextareaPGFocused && blockMessageFocusedIndexPG !== null) {
        const messageElementPG = this.$refs.textareasPG[blockMessageFocusedIndexPG];

        const textBefore =  this.paraphraseGenerated[blockMessageFocusedIndexPG].substring(0, MessageCursorPosition);
        const textAfter =  this.paraphraseGenerated[blockMessageFocusedIndexPG].substring(MessageCursorPosition);

        const emotionText = '<' + emotion + '>';
        const finalText = textBefore + emotionText + textAfter;

        this.$set(this.paraphraseGenerated, blockMessageFocusedIndexPG, finalText);

        const newPosition = textBefore.length + emotionText.length;
        this.MessageCursorPosition = newPosition;

        this.setCaretPosition(messageElementPG.$refs.input, newPosition);
      }
    },
    setCaretPosition(elem, caretPos) {
      if (elem !== null) {
        elem.focus();
        elem.selectionStart = caretPos;
        elem.selectionEnd = caretPos;

        setTimeout(() => {
          // Set the cursor at the end of the text after the value has been updated
          elem.selectionStart = caretPos;
          elem.selectionEnd = caretPos;
        }, 200);
      }
    },
    async clearMessageBlock(blockIndex) {
      if(this.actionMessages.args.length > 1) {
        this.actionMessages.args.splice(blockIndex, 1);
        this.readed.splice(blockIndex, 1)
      } else {
        this.actionMessages.args = [];
      }
    },
    async clearParaphraseGenerated(blockIndex) {
      if(this.paraphraseGenerated.length > 1) {
        this.paraphraseGenerated.splice(blockIndex, 1);
      } else {
        this.paraphraseGenerated = [];
      }
    },
    handleFocusMessageBlock(blockIndex) {
      this.blockMessageFocusedIndex = blockIndex;
      this.isTextareaFocused = true;
      this.isTextareaPGFocused = false;
    },
    handleFocusMessageBlockPG(blockIndex) {
      this.blockMessageFocusedIndexPG = blockIndex;
      this.isTextareaPGFocused = true;
      this.isTextareaFocused = false;
    },
    getCursuroPosition(event, index) {
      this.MessageCursorPosition = event.target.selectionStart;
      this.$nextTick(() => {
        if (this.$refs.textareas && this.$refs.textareas[index]) {
          this.$refs.textareas[index].focus();
        }
        this.blockMessageFocusedIndex = index;
      });
      this.messageBlockEvent = event.target;
    },
    getCursuroPositionPG(event, index) {
      this.MessageCursorPosition = event.target.selectionStart;
      this.$nextTick(() => {
        if (this.$refs.textareasPG && this.$refs.textareasPG[index]) {
          this.$refs.textareasPG[index].focus();
        }
        this.blockMessageFocusedIndex = index;
      });
      this.messageBlockEvent = event.target;
    },
    // async getActionArgsReaded(actionId, index) {
    //   try {
    //     const response = await this.$http.get(`/action/${actionId}/read/${index}`);
    //     return response.data?.action?.argsReaded;
    //   } catch (error) {
    //     console.error(`Error fetching action arguments: ${error}`);
    //     return [];
    //   }
    // },
    listenToParagraph(paragraph, index, isParaph = false) {

      const textTransform = this.transformerTexte(paragraph);
      let audioContext;
      if (window.AudioContext) {
        audioContext = new AudioContext();
      } else {
        // eslint-disable-next-line no-undef, new-cap
        audioContext = new webkitAudioContext();
      }

      if (isParaph) {
        this.loadingAudioIsParaph = true;
        this.activeIndexIsParaph = index
      } else {
        this.loadingAudioNoParaph = true
        this.activeIndexNoParaph = index;
      }


      this.$http
          .post(
              "/generate-audio",
              { speaker_id: "0", text: textTransform },
              {
                responseType: "arraybuffer",
              }
          )
          .then((data) => {
            const audioData = data.data;
            if (audioData.byteLength > 0) {   // check if the data is not empty
              this.playAudio(audioData,index);
            } else {
              console.error("No audio data received");
            }
            if (isParaph) {
              this.loadingAudioIsParaph = false;
            } else {
              this.loadingAudioNoParaph = false;
            }
          })
          .catch((error) => {
            console.log(error);
            if (isParaph) {
              this.loadingAudioIsParaph = false;
            } else {
              this.loadingAudioNoParaph = false;
            }
          });
    },
    playAudio(audioData,index) {
      var audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      let source = audioCtx.createBufferSource();
      let vm = this;
      audioCtx.decodeAudioData(audioData, function(buffer) {
        source.buffer = buffer;
        source.connect(audioCtx.destination);
        source.start(0);

        source.onended = () => {
          if (vm.readed[index] === false) {
            vm.$set(vm.readed, index, true);
          }
        };
      });
    },
    async setFavourite() {
      // Make the difference between saving the default node or a normal node
      if (
          (this.node.actions.length == 0 &&
              this.node.anchors.map((x) => x.name).includes("in") &&
              this.node.anchors.length <= 2) ||
          (this.node.actions.length == 0 &&
              !this.node.anchors.map((x) => x.name).includes("in") &&
              this.node.anchors.length <= 1) ||
          this.node.name == null || this.node.name === ""
      ) {
        this.$fire({
          title: "Oops.. Empty node",
          text: (this.node.name == null || this.node.name === "") ? "Please add a name to the node." : "You can't save an empty node!",
          type: "error",
          timer: 3000,
        });
        return;

      } else {
        this.savingModel = true;
        this.node.isSaved = true;
        await this.updateNode({
          skillId: this.$route.params.skillId,
          idNode: this.id,
          data: { isSaved: true, name: this.node.name },
        });
        this.$toasted.show("Node saved successfully", {
          theme: "toasted-primary",
          position: "top-center",
          duration: 2000,
        });
        // Add the selected node to template
        await this.getNode({
          skillId: this.$route.params.skillId,
          idNode: this.id,
        }).then((data) => {
          this.addSavedNodeToTemplate(data);
        });
      }

      let nodeRef = this.$refs;
      nodeRef.node.$el.style.backgroundColor = "lightsteelblue";
    },
    async unsetFavourite() {
      this.node.isSaved = false;
      await this.updateNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
        data: { isSaved: false, name: this.node.name },
      });
      // remove the selected node from template
      await this.getNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
      }).then((data) => {
        this.removeSavedNodeFromTemplate(data);
      });

      let nodeRef = this.$refs;
      nodeRef.node.$el.style.backgroundColor = "white";
    },
    async isFavourite() {
      const node = await this.getNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
      });
      if ((node.isSaved = true)) return true;
      else return false;
    },
    getFirstMessage(action) {
      if (action.actionType !== "message") return action.args[0];

      // Generate a random index within the array's length
      const randomIndex = Math.floor(Math.random() * action.args.length);

      return action.args[randomIndex];
    },
    async show() {
      const myNode = await this.getNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
      });
      // console.log("myNode.isSaved :", myNode);
      // console.log("this.node : ", this.node);
    },
    showNodeMenu(e) {
      this.$emit("hideContextMenu", this.id);
      this.$bus.$emit('contextMenuClick', this.id);
      this.$store.commit('setShowMenuLink', false)
      // this.showMenu = true;
      e.preventDefault();
      if (!this.showMenu) {
        this.x = e.clientX;
        this.y = e.clientY;
        this.newNodeX = e.offsetX;
        this.newNodeY = e.offsetY;
      }
      this.showMenu = false;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    showActionMenu(e, action) {
      this.$bus.$emit('contextMenuClick', "action");
      this.$store.commit('setShowMenuLink', false)
      e.preventDefault();

      this.actionIndex = this.node.actions.indexOf(action);
      this.actionContextMenu = action;
      if (this.actionMenu === false) {
        this.x = e.clientX;
        this.y = e.clientY;
        this.newNodeX = e.offsetX;
        this.newNodeY = e.offsetY;
      }
      this.actionMenu = false;
      this.$nextTick(() => {
        this.actionMenu = true;
      });
    },
    cloneNodes() {
      this.cloneNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
        data: {
          position: {
            x: this.node.position.x + 50,
            y: this.node.position.y + 50
          }
        }
      }).then((data) => {
        data.position.x = data.position.x + 50;
        data.position.y = data.position.y + 50;
        this.$emit("onUpdateClone", data);
      });
    },
    removeNodes() {
      this.$confirm(
          `Are you sure you want to delete the node <strong>${this.id}</strong> ?`
      ).then((res) => {
        if (res) {
          this.removeNode({
            skillId: this.$route.params.skillId,
            idNode: this.id,
          }).then(() => {
            this.$emit("onUpdateDelete", this.node);
            this.$store.dispatch('nodeRemoved');
          });
        }
      });
    },
    enableNameEditMode(shouldEnable = false) {
      this.nameEditMode = shouldEnable;

      if (this.nameEditMode) {
        return;
      }

      if (this.node.isSaved && this.node.name !== "") {
        this.updateNodeName();
        return;
      }

      if (!this.node.isSaved) {
        this.updateNodeName();
        return;
      }

      this.displayEmptyNodeError();
    },

    updateNodeName() {
      this.updateNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
        data: { name: this.node.name },
      });
    },

    displayEmptyNodeError() {
      this.$fire({
        title: "Oops.. Empty node",
        text: "You can't save node favorite with empty name!",
        type: "error",
        timer: 3000,
      });
    },
    createAnchorOnEvent(data) {
      this.createAnchor({
        skillId: this.$route.params.skillId,
        id: this.id,
        data,
      })
          .then((anchor) => {
            this.node.anchors.push(anchor);
          })
          .catch((err) => {
            console.log(err.response.data.message);

            this.$toasted.error(err.response.data.message);
          });
    },
    onDeletedAnchor(idAnchor) {
      this.$confirm(`Are you sure you want to delete the Anchor ?`).then(
          async (res) => {
            if (res) {
              this.removeAnchor({
                skillId: this.$route.params.skillId,
                idNode: this.id,
                idAnchor,
              }).then((anchor) => {
                for (var i = 0; i < this.node.anchors.length; i++) {
                  if (this.node.anchors[i]._id === idAnchor) {
                    this.node.anchors.splice(i, 1);
                    break;
                  }
                }
              });
            }
          }
      );
    },
    onAnchorChanged({ id, type, name, variable, value, available, color }) {
      this.updateAnchor({
        skillId: this.$route.params.skillId,
        idNode: this.id,
        idAnchor: id,
        data: { variable, value, name, available, color },
      }).then((anchor) => {
        for (var i = 0; i < this.node.anchors.length; i++) {
          if (this.node.anchors[i]._id === id) {
            this.node.anchors[i].name = anchor.name;
            this.node.anchors[i].variable = anchor.variable;
            this.node.anchors[i].value = anchor.value;
            this.node.anchors[i].available = anchor.available;
            this.node.anchors[i].color = anchor.color;
            break;
          }
        }
      });
    },
    callAction(action) {
      const defaultAddNodeData = {
        position: {
          x: this.newNodeX,
          y: this.newNodeY,
        },
      };

      if (action === "cloneNode") {
        this.cloneNodes();
      }
      if (action === "deleteNode") {
        this.removeNodes();
      }
      if (action === "commentNode") {
        this.expandComment = true;
        this.editingComment = true;
      }
      if (action === "connectNode") {
        this.$emit("onConnectNode", this.node);
      }
      if (action === "duplicateSelection") {
        localStorage.setItem("duplcateSelectionBool", true);
      }
    },
    shouldShowItem(item) {
      if (item.action === "duplicateSelection") {
        const selectedNodes = JSON.parse(localStorage.getItem("selectedNodes")) || [];

        return selectedNodes.length === 0;
      }
      // If showState is not defined or false, always show the item
      return false;
    },
    show(e) {
      e.preventDefault();
      console.log(e);
      if (this.showMenu === false) {
        this.x = e.clientX;
        this.y = e.clientY;
        this.newNodeX = e.offsetX;
        this.newNodeY = e.offsetY;
      }
      this.showMenu = false;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    async addComment() {
      await this.updateNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
        data: { comment: this.node.comment },
      });
      this.editingComment = false;
    },
    handleBookmark() {
      if (this.node.isSaved) {
        this.unsetFavourite();
      } else {
        this.setFavourite();
      }
    },
    connectionAnchor(event) {
      let eventData = {
        anchor: event.id,
        anchorOutState: event.anchorOutState,
        node: this.$refs.node.$el.id,
        nodeId: this.id,
      };
      this.$emit("onConnectionAnchor", eventData);
    },
    async markEndNode(event) {
      await this.updateNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
        data: { end: event },
      });
    },
    async MarkNonAvailableNode(event) {
      // await this.updateNode({
      //         skillId: this.$route.params.skillId,
      //         idNode: this.id,
      //         data: { available: event }
      // })
      // console.log("this result received in noce : ", {
      //   available: event.available,
      //   anchors: event.anchorsList,
      // });
    },
    handleHoverAnchor(event) {
      let nodesDom = document.getElementsByClassName("pertimm-node");
      if (event.active) {
        for (let node in nodesDom) {
          let foundNode = nodesDom[node].__vue__?.node;
          foundNode?.anchors.map((anchor) => {
            if (anchor._id === event.connection.targetId) {
              nodesDom[node].classList.add("selectedAnchor");
            }
          });
        }
      } else {
        for (let node in nodesDom) {
          let foundNode = nodesDom[node].__vue__?.node;
          foundNode?.anchors.map((anchor) => {
            if (anchor._id === event.connection.targetId) {
              nodesDom[node].classList.remove("selectedAnchor");
            }
          });
        }
      }
    },
    handleExpandComment() {
      this.expandComment = !this.expandComment;
      if (this.editingComment) this.expandComment = false;
    },
    EnableEditingComment() {
      this.editingComment = true;
      this.expandComment = false;
    },
    handleCommentToggle() {
      if (this.expandComment) this.expandComment = false;
    },
    openCommentMenu(event) {
      // console.log("Clicked !");
      this.x = event.clientX;
      this.y = event.clientY;
      this.showCommentMenu = true;
    },
    async deleteComment() {
      // console.log("deleting...!");
      (this.node.comment = ""),
          // this.addComment();
          await this.updateNode({
            skillId: this.$route.params.skillId,
            idNode: this.id,
            data: { comment: "" },
          });
    },
    handleDrop(e) {
      this.$emit("onDropUpdateData");
      this.canvas.connect({
        source: e.drag.el._jsPlumbRelatedElement,
        target: this.$refs.anchorIn[0]?.$options?.propsData?.id,
        hoverPaintStyle: { strokeWidth: "10px" },
      });
      this.$nextTick(()=> {
        this.$emit("onDropUpdateData");
      })
    },

    setupJsPlumbTargets() {
      if (this.$refs.anchorIn !== undefined) {
        let endpointAnchorId = this.$refs?.anchorIn[0]?.$options?.propsData?.id;
        this.canvas.makeTarget(
            this.$refs?.node?.$el,
            Object.assign({}, this.anchorDefaultOptions, {
              endpoint: "Blank",
              isTarget: true,
              uniqueEndpoint: true,
              dropOptions: {
                hoverClass: "drag-hover",
                drop: this.handleDrop.bind(this),
              },
              parameters: {
                _idTarget: endpointAnchorId,
                contextTarget: this.$refs.anchorIn[0],
                id: endpointAnchorId,
              },
            })
        );
      }
    },
   startChat() {
      this.patientId = localStorage.getItem("patientId");
      const patientId = this.patientId ?? this.demoPatientId;

      const url = `/projects/${this.$route.params.id}/chat/${this.userId}/patient/${patientId}`;
      // const patientId = this.patientId ? this.patientId : this.demoPatientId;
      // const url = `/projects/${this.$route.params.id}/chat/${this.userId}/patient/${patientId}`;
      //Set the context
      let newWindow = window.open('', '_blank');

      const currentURL = window.location.href;
      const lastID = currentURL.match(/\/([^/]+)\/?$/)[1]

      this.$http
          .put(
              `/projects/${this.$route.params.id}/skills/${lastID}`,
              {
                isStart: true,
                isLatent: false,
              }
          )
          .then(() => {
            this.getSkills().then(() => {
              this.editDialog = false;
              this.currentSkill = {};
            });
          })
          .catch((err) => {
            this.$notify({ type: "error", text: err.response.data.message });
          });
      const token = localStorage.getItem('authToken');
      this.$http
          .post(url, {
            metadata: {
              token
            },
            text: "Chat start from node",
            startFromNode: this.node,
          })
          .then((data) => {
            // Store data in the locale storage
            localStorage.setItem("chatData", JSON.stringify(data.data));

            // Open the chat
            const newUrl = `/project/${this.$route.params.id}/chat`;
            newWindow.location.href = newUrl;
          })
          .catch((error) => {
            // Handle error
            console.error("An error occurred:", error.message);
          });
    },
    async handleDoubleClickOnAction(index, action) {
      if (action.actionType !== "vikyAction") {
        this.readed = action.argsReaded
        this.actionMessages.args = action.args
        this.dialogEditAction = true;
        this.editingMessage = true;
        this.actionIndex = index;
      }
      else {
        const currentNode = await this.getNode({
          skillId: this.$route.params.skillId,
          idNode: this.id,
        });
        const nodeAction = currentNode.actions[index];
        if (nodeAction.name.includes('long')) {
          currentNode.actions[index].name = "Waiting for a short response";
        }
        else {
          currentNode.actions[index].name = "Waiting for a long response";
        };
        let newAction = await this.updateAction({
          skillId: this.$route.params.skillId,
          idNode: this.id,
          action: nodeAction,
          actionId: currentNode.actions[index]._id,
        });

        let updatedNode = await this.getNode({
          skillId: this.$route.params.skillId,
          idNode: this.id,
        });
        this.node.actions = updatedNode.actions;

      }
    },
    handleContextMenuClickEvent(eventSource) {
      if(eventSource !== "node") {
        this.showMenu = false;
        this.actionMenu = false;
      }
    }
  },
  computed: {
    ...mapState('httpSkills', ['skills']),
    isArgsEmpty() {
      return this.actionMessages.args.every(arg => arg.trim() === "");
    },
    canvas: {
      get() {
        return this.$store.state.canvas.canvas;
      },
    },
    anchors: {
      get() {
        const inAnchors = [];
        const outAnchors = [];

        this.node.anchors.forEach((anchor) => {
          if (anchor.out) {
            outAnchors.push(anchor);
          } else {
            inAnchors.push(anchor);
          }
        });

        return { in: inAnchors, out: outAnchors };
      },
    },
    sortedOutAnchors() {
      return [...this.anchors.out].sort((a, b) => {
        if (a.name === "default") return 1;
        if (b.name === "default") return -1;
        return 0;
      });
    },
    commentTitle: {
      get() {
        if (this.node.comment) {
          if (this.node.comment.length > 25) {
            return this.node.comment.substr(0, 20) + "...";
          } else {
            return this.node.comment;
          }
        }
      },
    },
    shouldDisplayConnectionAction: {
      get() {
        if (this.excludedNode) {
          return this.id !== this.excludedNode;
        } else {
          return false;
        }
      },
    },
    getSkillName() {
      return function(id) {
        const skill = this.skills.find((skill) => skill._id === id);
        return skill ? skill.name : "";
      }.bind(this);
    }
  },
  watch: {
    // actionMessages.args: {
    //   async handler(newValue, oldValue) {
    //     // console.log('watch actionMessages.args : ', this.actionMessages.args)
    //     if(newValue.length !== oldValue.length) {
    //       // Perform actions based on the change in length
    //       let action =this.node.actions.filter((action => {
    //         if(action.actionType === 'message' && action.args.includes(oldValue[0])) {
    //           return action
    //         }
    //       }))
    //       action[0].args = newValue;
    //       let actionIndex = this.node.actions.indexOf(action);
    //       if(actionIndex) this.node.actions[actionIndex] = action;
    //       let updatedAction = this.node.actions[actionIndex][0];
    //       await this.updateAction({
    //         skillId: this.$route.params.skillId,
    //         idNode: this.id,
    //         action: updatedAction,
    //         actionId: updatedAction._id,
    //       });
    //       const node = await this.getNode({
    //         skillId: this.$route.params.skillId,
    //         idNode: this.id,
    //       });
    //       this.node = node;
    //     }
    //   },
    //   deep: true // Set deep to true to watch changes inside the array
    // }
  },
  // mounted() {
  //   const self = this;
  //   self
  //   .getNode({ skillId: self.$route.params.skillId, idNode: self.id })
  //   .then((data) => {
  //       self.node = data;
  //       let nodeMessageAction = data.actions.filter(action => {
  //         if(action.actionType === "message") {
  //           self.actionMessages.args = action.args;
  //           return action;
  //         }
  //       })
  //       self.$nextTick(() => {
  //         self.$refs.node.$el.style.left = `${self.node.position.x}px`;
  //         self.$refs.node.$el.style.top = `${self.node.position.y}px`;

  //         self.canvas.draggable(self.$refs.node.$el, {
  //           stop: ({ finalPos }, ui) => {
  //             self.updateNode({
  //               skillId: self.$route.params.skillId,
  //               idNode: self.id,
  //               data: { position: { x: finalPos[0], y: finalPos[1] } },
  //             });

  //             for (let dbId in this.$parent.selectedElements) {
  //               const canvasId = this.$parent.selectedElements[dbId].canvasId;
  //               const currentNode = document.getElementById(canvasId);

  //               const currentPosition = {
  //                 x: currentNode.offsetLeft,
  //                 y: currentNode.offsetTop,
  //               };

  //               if (dbId !== self.id) {
  //                 self.updateNode({
  //                   skillId: self.$route.params.skillId,
  //                   idNode: dbId,
  //                   data: { position: currentPosition },
  //                 });
  //               }
  //             }
  //           },
  //         });
  //         if (self.node.isSaved) {
  //           let nodeRef = this.$refs;
  //           nodeRef.node.$el.style.backgroundColor = "lightsteelblue";
  //         }
  //         if (data.actions.length === 0) {
  //           this.showAddActionButton = true;
  //         } else {
  //           this.showAddActionButton = false;
  //         }
  //         const selectedNodes = localStorage.getItem("selectedNodes") || [];
  //         if (selectedNodes && selectedNodes.includes(this.id)) {
  //           this.$el.classList.add('selected');
  //         }
  //       });
  //     });
  //   // this.getIntents();

  //   // setTimeout(()=>{
  //   //   // this.$nextTick(()=>{
  //   //     if(this.$refs.anchorIn !== undefined) {
  //   //       let endpointAnchorId = this.$refs?.anchorIn[0]?.$options?.propsData?.id;
  //   //       this.canvas.makeTarget(
  //   //           this.$refs?.node?.$el,
  //   //           Object.assign({}, this.anchorDefaultOptions, {
  //   //             endpoint: 'Blank',
  //   //             isTarget: true,
  //   //             uniqueEndpoint: true,
  //   //             dropOptions: {
  //   //               hoverClass: 'drag-hover',
  //   //               drop: this.handleDrop
  //   //             },
  //   //             parameters: { _idTarget: endpointAnchorId, contextTarget: this.$refs.anchorIn[0], id: endpointAnchorId },
  //   //           })
  //   //         );
  //   //     }
  //   //   // })
  //   // }, 100)
  //   setTimeout(() => {
  //     if (this.$refs.anchorIn !== undefined) {
  //       let endpointAnchorId = this.$refs?.anchorIn[0]?.$options?.propsData?.id;
  //       this.canvas.makeTarget(
  //         this.$refs?.node?.$el,
  //         Object.assign({}, this.anchorDefaultOptions, {
  //           endpoint: "Blank",
  //           isTarget: true,
  //           uniqueEndpoint: true,
  //           dropOptions: {
  //             hoverClass: "drag-hover",
  //             drop: this.handleDrop.bind(this),
  //           },
  //           parameters: {
  //             _idTarget: endpointAnchorId,
  //             contextTarget: this.$refs.anchorIn[0],
  //             id: endpointAnchorId,
  //           },
  //         })
  //       );
  //     }
  //   }, 1000);
  // },
  created() {
    this.$bus.$on('contextMenuClick', this.handleContextMenuClickEvent);
  },
  mounted() {
    const self = this;

    if ( !self.$route.params.skillId ) return

    self.getNode({ skillId: self.$route.params.skillId, idNode: self.id })
        .then((data) => {
          self.node = data;

          let nodeMessageAction = data.actions.find(action => action.actionType === "message");

          if (nodeMessageAction) {
            self.actionMessages.args = nodeMessageAction.args;
          }

          self.$nextTick(() => {
            if (self.$refs.node && self.$refs.node.$el) {
              self.$refs.node.$el.style.left = `${self.node.position.x}px`;
              self.$refs.node.$el.style.top = `${self.node.position.y}px`;
            }

            self.canvas.draggable(self.$refs.node.$el, {
              stop: ({ finalPos }, ui) => {
                self.updateNode({
                  skillId: self.$route.params.skillId,
                  idNode: self.id,
                  data: { position: { x: finalPos[0], y: finalPos[1] }, name: this.node.name },
                });

                for (let dbId in this.$parent.selectedElements) {
                  const canvasId = this.$parent.selectedElements[dbId].canvasId;
                  const currentNode = document.getElementById(canvasId);

                  const currentPosition = {
                    x: currentNode.offsetLeft,
                    y: currentNode.offsetTop,
                  };

                  if (dbId !== self.id) {
                    self.updateNode({
                      skillId: self.$route.params.skillId,
                      idNode: dbId,
                      data: { position: currentPosition, name: this.node.name },
                    });
                  }
                }
              },
            });

            if (self.node.isSaved) {
              self.$refs.node.$el.style.backgroundColor = "lightsteelblue";
            }

            if (data.actions.length === 0) {
              this.showAddActionButton = true;
            } else {
              this.showAddActionButton = false;
            }

            const selectedNodes = localStorage.getItem("selectedNodes") || [];
            if (selectedNodes && selectedNodes.includes(this.id)) {
              this.$el.classList.add('selected');
            }

            self.setupJsPlumbTargets(); // Moved the jsPlumb setup to a separate function
          });
        });
  },
};
</script>

<style scoped>
.pertimm-node {
  position: absolute;
  z-index: 1;
}
.v-card--link:before {
  opacity: 0 !important;
}
.my-node {
  position: relative;
}
.node-name-input >>> input {
  text-align: center;
}

.node-name-label {
  /* min-width: 200px; */
  min-height: 39px;
  position: absolute;
  top: -30px;
  left: 0px;
  font-size: medium;
  font-weight: bold;
}
.height-200 {
  height: 200px;
}
.my-editor {
  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
  background: #2d2d2d;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example: */
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}
/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}
/* Node selection */
.selected {
  box-shadow: 0 0 10px 2px #00ced1; /* outer cyan */
}

.selectedAnchor {
  box-shadow: 0 0 10px 2px #f51010; /* outer cyan */
}

/* .wrap-action {
  margin: 2px 0px 2px 0px;
  border-radius: 5px !important;
  padding: 5px;
}

.wrap-action span {
  font-size: 14px;
}

.wrap-action-message{
  background-color: #E9E9E9;
}

.wrap-action-customAction {
  background-color: #CEBCFF;
}

.wrap-action-vikyAction {
  margin: 0px 0px 0px 0px;
  padding: 2px;

}
.wrap-action-vikyAction span {
  font-size: 11px;
  font-style: italic;
  text-align: center;
}

.actions-bloc {
  margin: 0px;
  padding: 10px;
} */

.jsPlumb-canvas-container22 {
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
  outline: none;
  overflow: hidden;
  max-height: 100vh;
  max-width: 100vw;
}

.v-alert {
  margin-bottom: 0px !important;
  padding: 16px 16px 0px 16px !important;
}

.expandDuv {
  margin-bottom: -25px !important;
  margin-left: 80px;
  position: absolute;
  width: 95%;
  top: 255px;
}

.paragraphsContainer {
  margin-left: 15px;
}

.paragraph {
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  align-items: center;
}

.white-text {
  color: white !important;
  font-weight: bold;
}

::v-deep .commentTextarea > .v-input__control > .v-input__slot {
  margin-top: 0px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

::v-deep .commentTextarea > .v-input__control > .v-input__slot::before {
  border: none !important;
}

::v-deep .commentTextarea > .v-input__control > .v-input__slot::after {
  border-color: #69cb85 !important;
}

::v-deep
.commentTextarea
> .v-input__control
> .v-input__slot
> .v-text-field__slot {
  padding: 5px;
}
.custom-textarea {
  border-radius: 18px; /* Border radius if needed */
}

::v-deep .commentTextareaPG > .v-input__control > .v-input__slot {
  border: 1px solid red !important;
  border-radius: 18px;
  padding-top: 10px;
}

::v-deep .v-text-field__details {
  display: none;
}
</style>
